export default __webpack_public_path__ + "static/media/symbol03.00ad01ad.svg";